import { SYSTEM_ROLE_LABEL, SYSTEM_ROLE_RANK, SystemRole } from '../../Enums/system-role.enum';
import { OperatorResponse } from '../../Interfaces/api/backoffice/operator.interface';

export class Operator {
  id = '';
  first_name: string | null = null;
  last_name: string | null = null;
  email: string | null = null;
  preferred_lang: string | null = null;
  preferred_theme: string | null = null;
  displayName: string | null = null;
  userPrincipalName: string | null = null;
  employeeId: string | null = null;
  photo: string | null = null;
  system_role: SystemRole | null = null;

  constructor(data: Partial<OperatorResponse> = {}) {
    Object.assign(this, data);
    this.system_role = Operator.toSystemRole(data.system_role ?? null);
  }

  get name(): string {
    const composed = [this.first_name, this.last_name].filter(Boolean).join(' ').trim();

    return this.displayName || composed || this.email || '';
  }

  get initialsSeed(): string {
    return this.name || this.userPrincipalName || '';
  }

  get systemRoleLabelKey(): string {
    return this.system_role ? SYSTEM_ROLE_LABEL[this.system_role] : '';
  }

  atLeast(role: SystemRole): boolean {
    if (!this.system_role) {
      return false;
    }

    return SYSTEM_ROLE_RANK[this.system_role] >= SYSTEM_ROLE_RANK[role];
  }

  private static toSystemRole(value: string | null): SystemRole | null {
    const known = Object.values(SystemRole) as string[];

    return value !== null && known.includes(value) ? (value as SystemRole) : null;
  }
}
